import { render, staticRenderFns } from "./UplodeImageDirect.vue?vue&type=template&id=778dbcf6&scoped=true"
import script from "./UplodeImageDirect.vue?vue&type=script&lang=js"
export * from "./UplodeImageDirect.vue?vue&type=script&lang=js"
import style0 from "./UplodeImageDirect.vue?vue&type=style&index=0&id=778dbcf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778dbcf6",
  null
  
)

export default component.exports